import React, { Component } from "react";
// import { Glyphicon } from "react-bootstrap"
import ModalInfo from "../../containers/ModalInfo";
import Notifications from "react-notify-toast";
import RIcon from "../../assets/icons/R_icon.svg";
import RLogo from "../../assets/icons/logo.svg";
import UserRainbow from "../../assets/icons/user_Rainbow.svg";
import LanguageSwitcher from "../../components/LanguageSwitcher/LanguageSwitcher";
import withTranslation from "../../i18n/withTranslation";

class Header extends Component {
   state = {
      logoutModal: false
   };

   toggleSidemenu = () => {
      const sidemenu = document.getElementById("sidebar-navigation");
      const pageWrapper = document.getElementsByClassName("hotels__slide")[0];
      const header = document.getElementsByClassName("header")[0];
      const headerLogo = document.getElementById("header__logo");
      headerLogo.src = window.innerWidth > 1200 ? RLogo : RIcon;
      if (sidemenu.classList.contains("sidebar-navigation-wrapper--open")) {
         sidemenu.classList.remove("sidebar-navigation-wrapper--open");
         header && header.classList.remove("header--open");
         pageWrapper && pageWrapper.classList.remove("hotels__slide--open");
      } else {
         sidemenu.classList.add("sidebar-navigation-wrapper--open");
         header && header.classList.add("header--open");
         pageWrapper && pageWrapper.classList.add("hotels__slide--open");
      }
   };

   render() {
      const {
         orders,
         rezydent,
         canceled_vouchers,
         location,
         tripsHeader,
         goBack,
         logout,
         user,
         fetchDateInfo,
         t
      } = this.props;
      let count_orders, count_vouchers;
      const logoImage = window.innerWidth > 1200 ? RLogo : RIcon;
      if (tripsHeader) {
         count_orders = orders.length;
         count_vouchers = canceled_vouchers.length;
      }
      return (
         <div>
            <ModalInfo
               show={this.state.logoutModal}
               onHide={() => this.setState({ logoutModal: false })}
               text={t("menu.logoutConfirm")}
            >
               <div>
                  <p className="info_message">{t("menu.logoutConfirm")}</p>
                  <div className="text-right">
                     <button className="btn info__btn info__btn--inverted" onClick={() => logout()}>
                        {t("common.actions.yesUpper")}
                     </button>
                     <button
                        className="btn info__btn"
                        onClick={() => this.setState({ logoutModal: false })}
                     >
                        {t("common.actions.noUpper")}
                     </button>
                  </div>
               </div>
            </ModalInfo>

            <React.Fragment>
               <Notifications
                  options={{
                     colors: {
                        warning: { color: "white", backgroundColor: "#D72567" },
                        success: { background: "#28A745", color: "white" }
                     }
                  }}
               />
            </React.Fragment>
            <header className="header">
               <div>
                  <div className="header__container">
                     <div className="flex flex--center margin--right">
                        <img
                           id="header__logo"
                           src={logoImage}
                           alt="rep-panel-logo"
                           className="header__logo margin--right"
                        />
                        <span
                           onClick={this.toggleSidemenu}
                           className="icon-menu_icon toggleIcon"
                        ></span>
                     </div>
                     {location.pathname !== "/" && location.pathname !== "/tasks-scheduler" && (
                        <div className="header__buttons">
                           <React.Fragment>
                              <button
                                 onClick={goBack}
                                 className={`back-button button button__custom button__custom--desktop button__rounded--flat button__rounded margin--right`}
                              >
                                 <span className="icon-arrow_left"></span>
                                 <span className="margin__small--left">
                                    {t("common.actions.back")}
                                 </span>
                              </button>
                           </React.Fragment>
                        </div>
                     )}
                     {tripsHeader && (
                        <div className="header__connection">
                           <div className="inside flex flex--center">
                              {count_orders === 0 && count_vouchers === 0 ? (
                                 <span className="box ok">
                                    <span className="icon icon-smile_icon"></span>
                                    {t("menu.dataSynced")}
                                 </span>
                              ) : (
                                 [
                                    count_orders > 0 && (
                                       <span key={1} className="box warn">
                                          <span className="icon-alert_icon icon"></span>
                                          <span className="text--large">{count_orders}</span>{" "}
                                          {this.orderText(count_orders)}
                                       </span>
                                    ),
                                    count_vouchers > 0 && (
                                       <span key={2} className="box warn">
                                          <span className="icon-alert_icon icon"></span>
                                          <span className="text--large">{count_vouchers}</span>{" "}
                                          {this.voucherText(count_vouchers)}
                                       </span>
                                    )
                                 ]
                              )}
                           </div>
                        </div>
                     )}
                     <div className="header__logout">
                        <LanguageSwitcher />
                        <img src={UserRainbow} className="user-avatar" alt="Avatar" />
                        <span className="header__box">{rezydent}</span>
                        {/*<span className="logout"><Glyphicon glyph="off" onClick={() => this.setState({logoutModal: true})}/></span>*/}
                     </div>
                     <div className="header__logout header__logout--desktop">
                        <LanguageSwitcher />
                        <img src={UserRainbow} className="user-avatar" alt="Avatar" />
                        <span className="header__box header__box--desktop">{rezydent}</span>
                        {user && (
                           <button
                              onClick={() => this.setState({ logoutModal: true })}
                              className="button button__custom button__custom--desktop margin--right button__rounded--flat button__rounded"
                           >
                              <span>{t("menu.logout")}</span>
                              {/*<span className="logout"><Glyphicon glyph="off"/></span>*/}
                           </button>
                        )}
                     </div>
                  </div>
                  {tripsHeader && fetchDateInfo()}
               </div>
            </header>
         </div>
      );
   }
}

export default withTranslation(Header);
